import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Compass } from "lucide-react";

export default function NotFound() {
  return (
    <section className="pt-40 pb-28 px-6 text-center max-w-xl mx-auto">
      <div className="h-14 w-14 rounded-full border border-border/80 bg-secondary/30 flex items-center justify-center mx-auto mb-6 text-primary">
        <Compass className="h-7 w-7" />
      </div>
      <p className="font-mono text-[11px] tracking-[0.22em] uppercase text-primary mb-3">
        404 · Page Not Found
      </p>
      <h1 className="text-4xl sm:text-5xl font-medium tracking-display mb-4">
        Destination Unmapped
      </h1>
      <p className="text-foreground/75 text-base sm:text-lg mb-8 leading-relaxed">
        The route you are navigating to does not exist in the fmi.dev architecture index. Check the URL or return to verified systems.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.18em] uppercase px-6 py-2.5 rounded-full bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> Return Home
        </Link>
        <Link
          to="/works"
          className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.18em] uppercase px-6 py-2.5 rounded-full border border-border/80 bg-card/40 text-foreground/80 hover:text-foreground hover:bg-secondary/40 transition-colors"
        >
          Selected Works
        </Link>
      </div>
    </section>
  );
}
